import React, { useEffect, useMemo, useRef } from "react";
import { Chart } from "chart.js";
import { useSelector } from "react-redux";

export default function SalesBarChart({ title, desc, type }) {
  const clientsByDay = useSelector((state) => state.admin.ClientsByDay);
  const clientRegistrationsByDay = useSelector((state) => state.admin.ClientRegistrationsByDay);
  const ref = useRef();
  const data = useMemo(
    () => ({
      labels: type === "Clients" ? clientsByDay.map((a) => a.datekey) : clientRegistrationsByDay.map((a) => a.datekey),
      datasets: [
        {
          // label: 'dataset 1',
          backgroundColor: "#5d78ff",
          data: type === "Clients" ? clientsByDay.map((a) => a.total) : clientRegistrationsByDay.map((a) => a.total),
        },
        // {
        //   // label: 'dataset 2',
        //   backgroundColor: "#e0e0ff", //  f3f3fb
        //   data: [15, 20, 25, 30, 25, 20, 15, 20, 25, 30, 25, 20, 15, 10, 15, 20]
        // }
      ],
    }),
    [clientsByDay, clientRegistrationsByDay, type],
  );

  useEffect(() => {
    const chart = new Chart(ref.current, {
      data,
      type: "bar",
      options: {
        title: { display: false },
        tooltips: {
          intersect: false,
          mode: "nearest",
          xPadding: 10,
          yPadding: 10,
          caretPadding: 10,
        },
        legend: { display: false },
        responsive: true,
        maintainAspectRatio: false,
        barRadius: 4,
        scales: {
          xAxes: [{ display: false, gridLines: false, stacked: true }],
          yAxes: [{ display: false, stacked: true, gridLines: false }],
        },
        layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
      },
    });

    return () => {
      chart.destroy();
    };
  }, [data]);

  return (
    <div className="kt-widget14">
      <div
        className="kt-widget14__header"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <h3 className="kt-widget14__title" style={{ margin: 0 }}>
          {title}
        </h3>

        <span className="kt-widget14__desc">{desc}</span>
      </div>{" "}
      <div className="kt-widget14__chart" style={{ height: "140px" }}>
        <canvas ref={ref} />
      </div>
    </div>
  );
}
